import { render, staticRenderFns } from "./addSender.vue?vue&type=template&id=1dfc14ae&scoped=true&"
import script from "./addSender.vue?vue&type=script&lang=js&"
export * from "./addSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfc14ae",
  null
  
)

export default component.exports